import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-634bdf95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-28 h-full" }
const _hoisted_2 = { class: "ml-8" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-2xl text-primary" }, "Your Bag", -1))
const _hoisted_4 = { class: "my-3 text-gray-600" }
const _hoisted_5 = {
  id: "product-cart",
  class: "overflow-auto flex-grow mt-8"
}

import { computed } from "vue";
import { useStore } from "vuex";

import ShopingCartItem from "../common/ShopingCartItem.vue";

import { IProduct } from "@/interfaces/IProduct";


export default /*#__PURE__*/_defineComponent({
  props: {
  cart: {
    type: Boolean,
    default: false,
    required: true,
  },
  cartBackdrop: {
    type: Boolean,
    default: false,
    required: true,
  },
},
  emits: ["toggleBackdrop", "checkout"],
  setup(__props, { emit }) {



const store = useStore();
const shoppingCartList = computed(() => store.state.shoppingCartList);
const totalPrice = computed(() =>
  shoppingCartList.value
    .map((e: IProduct) => e.price * e.quantity)
    .reduce((a: number, b: number) => a + b, 0)
);


const toggleBackdrop = () => emit("toggleBackdrop");
const checkout = () => emit("checkout");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      id: "cart",
      class: _normalizeClass([{ 'toggle-cart': __props.cart }, "fixed top-0 right-0 z-40 w-full h-full bg-white shadow-xl xl:max-w-lg cart"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, " Total: (" + _toDisplayString(_unref(shoppingCartList).length) + " Item) $ " + _toDisplayString(_unref(totalPrice)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shoppingCartList), (product) => {
            return (_openBlock(), _createBlock(ShopingCartItem, {
              key: product.id,
              product: product
            }, null, 8, ["product"]))
          }), 128))
        ]),
        _createElementVNode("button", {
          class: "fixed bottom-0 p-4 mb-[5.7rem] w-full text-white uppercase xl:mb-0 xl:max-w-lg bg-primary",
          onClick: checkout
        }, " Checkout ")
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([{
        invisible: __props.cartBackdrop,
        'shopping-cart-backdrop--no-active': __props.cartBackdrop,
      }, "fixed inset-0 visible z-20 w-full h-full bg-black shopping-cart-backdrop"]),
      onClick: toggleBackdrop
    }, null, 2)
  ]))
}
}

})